import { css } from 'linaria';
import { breakpoints } from 'common/styles/breakpoints';

const notificationMessageHeight = 148;
const notificationMessageMobileHeight = 188;
const mediaSize = 225;
const maxNotificationHeight = 188;
const minScreenGap = 32;
const minScreenHeight = mediaSize + maxNotificationHeight + minScreenGap;

export const mediaContainer = css`
  position: relative;
  display: flex;
  height: calc(90% - ${notificationMessageHeight}px);
  transition: height 300ms ease-out;
  width: 100%;
  margin-bottom: var(--space-400);

  ${breakpoints.only.mobile} {
    height: calc(90% - ${notificationMessageMobileHeight}px);
  }

  @media (max-height: ${minScreenHeight}px) {
    height: 225px;
    margin-bottom: 0;
  }
`;

export const maxHeight = css`
  height: 100vh;
`;

export const mediaStyle = css`
  display: flex;
  position: absolute;
  width: ${mediaSize}px;
  height: ${mediaSize}px;
  margin: auto;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;

export const animationZIndex = css`
  z-index: 99998;
`;

export const introContainerStyle = css`
  background-color: var(--background-primary);
  width: 100%;
  height: 100%;
  z-index: 99998;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  opacity: 1;
  transition: opacity 300ms ease-out;

  @media (max-height: ${minScreenHeight}px) {
    display: grid;
    gap: var(--space-400);
  }
`;

export const smallHeightOverflowYScroll = css`
  @media (max-height: ${minScreenHeight}px) {
    overflow-y: scroll;
  }
`;

export const notificationContainer = css`
  position: relative;
  display: flex;
  flex-direction: column;
  text-align: center;
  z-index: 99999;
  padding: 0 var(--space-200);
  gap: var(--space-500);
  opacity: 1;
  transition: opacity 300ms ease-out;

  ${breakpoints.only.mobile} {
    gap: var(--space-400);
  }
`;

export const opacityInvisible = css`
  opacity: 0;
`;

export const notificationTextBlock = css`
  display: flex;
  flex-direction: column;
  gap: var(--space-150);
`;

export const notificationHeading = css`
  font-weight: 700;
  font-size: 22px;
  line-height: 24px;
  color: var(--text-primary);
  margin: 0 auto;
`;

export const notificationDescription = css`
  margin: 0 auto;
  font-size: 18px !important;
`;

export const notificationCloseButton = css`
  width: 284px;
  margin: 0 auto;
  background-color: var(--control-accent) !important;
  color: var(--text-primary) !important;

  &:hover {
    background-color: var(--control_hover-primary) !important;
  }
`;

export const smallHeightAdditionalMargin = css`
  @media (max-height: ${minScreenHeight}px) {
    margin-bottom: var(--space-125);
  }
`;
